import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { App } from './App';
// Microsoft Clarity
const clarityScript = document.createElement('script');
clarityScript.async = true;
clarityScript.src = 'https://www.clarity.ms/tag/wdj4p77ads';
document.head.appendChild(clarityScript);
(window as any).clarity = (window as any).clarity || function () {
  ;
  ((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
};
render(<BrowserRouter data-id="element-307">
    <App data-id="element-308" />
  </BrowserRouter>, document.getElementById('root'));